























































































































import { Component, Mixins } from 'vue-property-decorator';
import ProductIntegrationMixin from '@/mixins/vue/ProductIntegrationMixin';
import GAErrorEvent from '@/mixins/vue/gAnalytics/GAErrorEvent';
import RecTextField from '@/components/global/input/RecTextField.vue';
import { auth } from '@/plugins/papybase/papybaseInit';
import { MUTATE_AUTH } from '@/store/modules/auth';
import { AuthErrorCode, AuthInfo, Error } from '@luxtag/papybase';
import SimpleDialog from '@/components/global/SimpleDialog.vue';

@Component({
    components: {
        RecTextField,
        SimpleDialog,
    },
    $_veeValidate: { validator: 'new' },
})
export default class LoginForm extends Mixins(ProductIntegrationMixin, GAErrorEvent) {
    public showProgress= false;

    public showPassword = false;

    public showSimpleDialog = false;

    public messageHeader = '';
    public messageContent = '';

    public form = {
        email: '',
        password: '',
    }

    handleClickGoogleSignIn() {
        this.signInEvent('Sign in with google', 'Sign in with google button');
        const that = this;

        this.$gAuth.signIn()
            .then(async (user: any) => {
                if (this.isLogin) {
                    this.signInEvent('Sign in with google', false);
                    this.messageHeader = 'Login failed';
                    this.messageContent = 'Login failed because You have been login with different account, please refresh your browser';
                    this.showSimpleDialog = true;
                } else {
                    // On success do something, refer to https://developers.google.com/api-client-library/javascript/reference/referencedocs#googleusergetid
                    const { access_token } = user.getAuthResponse();
                    try {
                        const authInfo = await auth.signInWithGoogle(access_token);
                        that.signInEvent('Sign in with google', false);
                        that.loginSuccess(authInfo, false);
                    } catch (error) {
                        this.errorEvent('gAuth.signIn', error);
                        console.error(error);
                        this.messageHeader = 'Login failed';
                        this.messageContent = 'This email can\'t login with "Sign in With Google" button because you registered this email with sign up form before, please use sign in form to login';
                        this.showSimpleDialog = true;
                    }
                }
            })
            .catch((error: any) => {
                console.error(error);
            // On fail do something
            });
    }

    public signInEvent(action: string, label: any) {
        this.$ga.event('Signin', 'click', action, label);
    }

    public async signIn() {
        // prevent for sign in to work while progress is show up
        if (this.showProgress) return;

        this.signInEvent('Sign in', 'Sign in button');

        const valid = await this.$validator.validateAll();
        if (valid) {
            this.showProgress = true;
            auth.signInWithIdentifierAndPasswordAsMerchant(this.form.email, this.form.password)
                .then(async (user) => {
                    this.loginSuccess(user, true);
                }).catch((err) => {
                    this.errorEvent('signInWithIdentifierAndPasswordAsMerchant', err.message);
                    this.addAuthError(err);
                }).finally(() => {
                    this.showProgress = false;
                });
        }
    }

    public async loginSuccess(user: AuthInfo, isLoginByEmail: boolean) {
        // get template
        await this.integrateProductListFromBackEndToLocalStorage(user.jwt);
        const theUser: any = user;
        theUser.login = true;
        theUser.isLoginByEmail = isLoginByEmail;
        this.$store.commit(MUTATE_AUTH, theUser);
        this.$router.replace('/');
    }

    public addAuthError(error:Error) {
        let fieldName = '';

        switch (error.code) {
                case AuthErrorCode.USER_NOT_FOUND:
                    fieldName = 'password';
                    break;
                case AuthErrorCode.INVALID_EMAIL:
                    fieldName = 'email';
                    break;
                case AuthErrorCode.INVALID_IDENTIFIER:
                    fieldName = 'email';
                    break;
                case AuthErrorCode.INVALID_PASSWORD:
                    fieldName = 'password';
                    break;
                case AuthErrorCode.INVALID_USERNAME:
                    fieldName = 'email';
                    break;
                default:
                    fieldName = 'email';
                    break;
        }

        const field = this.$validator.fields.find({ name: fieldName });
        if (!field) return;

        this.errors.add({
            id: field.id,
            field: field.name,
            msg: error.message,
        });
    }

    public goToSignUp() {
        this.signInEvent('Go to signup', 'create account');
        this.$router.push('/signup');
    }

    public goToForgotPassword() {
        this.signInEvent('Go to forgot password', 'forgot password');
        this.$router.push('/forgot-password');
    }

    get isLogin() {
        const storage = window.localStorage.getItem('Papyrus');
        let parsedStorage;
        if (storage) {
            parsedStorage = JSON.parse((storage as any));
            if (parsedStorage.auth) {
                return parsedStorage.auth.login;
            }
            return false;
        }
        return false;
    }
}
